/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 */

import React, { Suspense } from 'react';

const LazyDevCockpit = import.meta.env.DEBUG === 'true'
  ? React.lazy(() => import('./components/DevCockpitRoot'))
  : null;

if (import.meta.env.DEBUG === 'true') {
  import('./services/env-overrides').then((m) => m.applyEnvOverrides());
}

export const DevCockpitProvider: React.FC = () => {
  if (!LazyDevCockpit) return null;
  return (
    <Suspense fallback={null}>
      <LazyDevCockpit />
    </Suspense>
  );
};

export default DevCockpitProvider;
